var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"state"}},[(_vm.flag == 2)?_c('div',{staticClass:"phone"},[(_vm.dialogData.flag)?_c('state_dialog',{attrs:{"myDialogData":_vm.dialogData}}):_vm._e()],1):_vm._e(),(_vm.flag == 1)?_c('div',{staticClass:"PC"},[(_vm.dialogData.flag)?_c('state_dialog_PC',{attrs:{"myDialogData":_vm.dialogData}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }